import styled from 'styled-components'
import { variant } from 'styled-system'

import Text from './Text'

// We also use CTA values within the Button.js config.
// We define their defaultValues in an object and destructure it where needed.

export const defaultValues = {
  fontFamily: 'proxima-nova',
  fontWeight: 700,
  fontSize: '18px',
  letterSpacing: '0.9px',
  lineHeight: '24px',
  textTransform: 'uppercase'
}

const CTA = styled(Text)(
  variant({
    variants: {
      default: {
        ...defaultValues
      },
      small: {
        ...defaultValues,
        fontWeight: 100,
        fontSize: 2
      },
      responsive: {
        ...defaultValues,
        fontWeight: 100,
        fontSize: ['14px', '15px', '15px']
      }
    }
  })
)

CTA.defaultProps = {
  variant: 'default'
}

export default CTA
